export const CART_MINIMUM_AMOUNT = 49
// clients want to show a different minimum amount shown than the actual minimum amount
export const CART_MINIMUM_AMOUNT_SHOWN = 50
